import gsap from "gsap";
import { SplitText } from "gsap/SplitText";
import { colors } from "~/_variables";

export default function heading() {
  const heading = SplitText.create(".section-contact .heading:not(.nochange)", {
    type: "chars",
  });

  heading.chars.forEach((char, i) => {
    gsap.set(char, { color: colors[i % 7] });
  });

  gsap
    .timeline()
    .from(
      heading.chars,
      {
        autoAlpha: 0,
        duration: 0.2,
        ease: "none",
        stagger: {
          amount: 0.3,
        },
      },
      "<"
    )
    .to(
      heading.chars,
      {
        color: "#000",
        duration: 0.2,
        ease: "none",
        stagger: {
          amount: 0.3,
        },
      },
      "<0.3"
    );
}
